import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, unref as _unref, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-81b3e02e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-calendar-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Add New Calendar", -1))
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Calendar Name", -1))
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Description", -1))
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "type" }, "Calendar Type", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "school" }, "School Calendar", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "district" }, "District Calendar", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 0,
  class: "form-group"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "schoolId" }, "School", -1))
const _hoisted_15 = { class: "school-select-container" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select a school", -1))
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 1,
  class: "form-group"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "districtId" }, "District", -1))
const _hoisted_20 = { class: "district-select-container" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select a district", -1))
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "academicYear" }, "Academic Year", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select academic year", -1))
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "form-row" }
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "startDate" }, "Start Date", -1))
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "endDate" }, "End Date", -1))
const _hoisted_32 = { class: "form-actions" }
const _hoisted_33 = ["disabled"]

import { ref, reactive, onMounted, computed, watch } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";
import { API_URL } from "../config";
import { getErrorMessage } from "../types";
import type { OrganizationRecord } from "../types";

interface DistrictSummary {
  id: number;
  name: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AddCalendarView',
  setup(__props) {

const router = useRouter();
const loading = ref(false);
const error = ref("");
const schools = ref<OrganizationRecord[]>([]);
const schoolSearch = ref("");
const districts = ref<DistrictSummary[]>([]);
const districtSearch = ref("");

// Generate academic years (current year - 2 to current year + 5)
const currentYear = new Date().getFullYear();
const academicYears = Array.from({ length: 8 }, (_, i) => currentYear - 2 + i);

const formData = reactive({
  name: "",
  description: "",
  type: "school",
  academicYear: currentYear.toString(),
  startDate: "",
  endDate: "",
  schoolId: "",
  districtId: "",
});

// Computed property for filtered and sorted schools
const filteredSchools = computed(() => {
  return schools.value
    .filter((school) =>
      school.name.toLowerCase().includes(schoolSearch.value.toLowerCase())
    )
    .sort((a, b) => a.name.localeCompare(b.name));
});

// Computed property for filtered and sorted districts
const filteredDistricts = computed(() => {
  return districts.value
    .filter((district) =>
      district.name.toLowerCase().includes(districtSearch.value.toLowerCase())
    )
    .sort((a, b) => a.name.localeCompare(b.name));
});

// Watch for type changes to reset selections
watch(
  () => formData.type,
  (newType) => {
    if (newType === "school") {
      formData.schoolId = "";
      formData.districtId = "";
    } else {
      formData.schoolId = "";
      formData.districtId = "";
    }
  }
);

// Fetch schools
const fetchSchools = async () => {
  try {
    const response = await axios.get(`${API_URL}/organizations`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    schools.value = response.data;
  } catch (err: unknown) {
    error.value = getErrorMessage(err, "Failed to fetch schools");
    console.error("Error fetching schools:", err);
  }
};

// Fetch districts
const fetchDistricts = async () => {
  try {
    const response = await axios.get(`${API_URL}/districts`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    districts.value = response.data;
  } catch (err: unknown) {
    error.value = getErrorMessage(err, "Failed to fetch districts");
    console.error("Error fetching districts:", err);
  }
};

const handleSubmit = async () => {
  loading.value = true;
  error.value = "";

  try {
    const submitData = {
      ...formData,
      schoolId: formData.type === "school" ? formData.schoolId : undefined,
      districtId:
        formData.type === "district" ? formData.districtId : undefined,
    };

    await axios.post(`${API_URL}/calendar`, submitData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    router.push("/calendar");
  } catch (err: unknown) {
    error.value = getErrorMessage(err, "Failed to create calendar");
    console.error("Error creating calendar:", err);
  } finally {
    loading.value = false;
  }
};

const goBack = () => {
  router.push("/calendar");
};

onMounted(() => {
  fetchSchools();
  fetchDistricts();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(error.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      onSubmit: _withModifiers(handleSubmit, ["prevent"]),
      class: "calendar-form"
    }, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "name",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.name) = $event)),
          required: "",
          placeholder: "Enter calendar name"
        }, null, 512), [
          [_vModelText, formData.name]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("textarea", {
          id: "description",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.description) = $event)),
          placeholder: "Enter calendar description"
        }, null, 512), [
          [_vModelText, formData.description]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _withDirectives(_createElementVNode("select", {
          id: "type",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.type) = $event)),
          required: ""
        }, _hoisted_12, 512), [
          [_vModelSelect, formData.type]
        ])
      ]),
      (formData.type === 'school')
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "schoolSearch",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((schoolSearch).value = $event)),
                placeholder: "Search schools...",
                class: "school-search"
              }, null, 512), [
                [_vModelText, schoolSearch.value]
              ]),
              _withDirectives(_createElementVNode("select", {
                id: "schoolId",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.schoolId) = $event)),
                required: ""
              }, [
                _hoisted_16,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredSchools.value, (school) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: school.id,
                    value: school.id
                  }, _toDisplayString(school.name), 9, _hoisted_17))
                }), 128))
              ], 512), [
                [_vModelSelect, formData.schoolId]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (formData.type === 'district')
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "districtSearch",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((districtSearch).value = $event)),
                placeholder: "Search districts...",
                class: "district-search"
              }, null, 512), [
                [_vModelText, districtSearch.value]
              ]),
              _withDirectives(_createElementVNode("select", {
                id: "districtId",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.districtId) = $event)),
                required: ""
              }, [
                _hoisted_21,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDistricts.value, (district) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: district.id,
                    value: district.id
                  }, _toDisplayString(district.name), 9, _hoisted_22))
                }), 128))
              ], 512), [
                [_vModelSelect, formData.districtId]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _withDirectives(_createElementVNode("select", {
          id: "academicYear",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.academicYear) = $event)),
          required: ""
        }, [
          _hoisted_25,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(academicYears), (year) => {
            return (_openBlock(), _createElementBlock("option", {
              key: year,
              value: year
            }, _toDisplayString(year), 9, _hoisted_26))
          }), 128))
        ], 512), [
          [_vModelSelect, formData.academicYear]
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _withDirectives(_createElementVNode("input", {
            type: "date",
            id: "startDate",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.startDate) = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, formData.startDate]
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _withDirectives(_createElementVNode("input", {
            type: "date",
            id: "endDate",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.endDate) = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, formData.endDate]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("button", {
          type: "button",
          class: "btn-cancel",
          onClick: goBack
        }, "Cancel"),
        _createElementVNode("button", {
          type: "submit",
          class: "btn-submit",
          disabled: loading.value
        }, _toDisplayString(loading.value ? "Creating..." : "Create Calendar"), 9, _hoisted_33)
      ])
    ], 32)
  ]))
}
}

})